import React from 'react';
import styled from 'styled-components';

import { RED } from '../config/colors';

const StyledErrorBoundary = styled.div`
    height: ${props => props.height ? props.height : 'auto'};
`;

const StyledErrorBoundaryInfoMessage = styled.div`
    max-width: 1170px;
    margin: 0 auto;
    border: 2px dotted ${RED};
    border-radius: 8px;
    padding: 30px;
    background-color: #FFE2E2;
    color: #BF5454;
    text-align: center;
    
    @media screen and (max-width: 1920px) and (min-width: 1024px) {
        max-width: 980px;
    }
`;

const StyledErrorBoundaryText = styled.p`
    font-family: "adelle", sans;
    font-size: 38px;
    font-weight: bold;
    margin: 0;
    
    @media screen and (max-width: 1920px) and (min-width: 1024px) {
        font-size: 30px;
    }
`;

const StyledErrorBoundaryReloadButton = styled.button`
    font-size: 22px;
    margin-top: 15px;
    
    @media screen and (max-width: 1920px) and (min-width: 1024px) {
        font-size: 18px;
        margin-top: 12px;
    }
`;

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false
        };

        this.onClickReload = this.onClickReload.bind(this);
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true });
    }

    onClickReload() {
        document.location.reload();
    }

    render() {
        if(this.state.hasError) {
            return (
                <StyledErrorBoundaryInfoMessage>
                    <StyledErrorBoundaryText>Vi har just nu tekniska problem. Ring vår kundtjänst för beställningar och frågor. Tel. 08 500 000 45</StyledErrorBoundaryText>
                    <StyledErrorBoundaryReloadButton className="button button--red" onClick={this.onClickReload}>
                        Ladda om sidan
                    </StyledErrorBoundaryReloadButton>
                </StyledErrorBoundaryInfoMessage>
            );
        }

        return (
            <StyledErrorBoundary className="error-boundary" {...this.props}>
                { this.props.children }
            </StyledErrorBoundary>
        );
    }
}
